import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionsGuard } from '@core/guard/permissions.guard';
import { PageSelectionReportComponent } from './page-selection-report/page-selection-report.component';

const routes: Routes = [
  {
    path: '',
    component: PageSelectionReportComponent,
    canActivate: [PermissionsGuard],
    data: { permissions: ['core.report-gna.get'] }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesReportCoreRoutingModule { }
